import React from 'react';
import { Card, Icon, Row, Col } from 'antd';
import './statisticsWidget.css';

const InfoElement = ({ primaryText, secondaryText, primaryColor, secondaryColor }) => {
  const primaryTextStyle = {
    fontSize: '24px',
    color: primaryColor
  };

  const secondaryTextStyle = {
    fontSize: '12px',
    color: secondaryColor
  };

  return (
    <div className="statistics-widget-content__info-element">
      <div className="info-group">
        <div className="primary-text" style={primaryTextStyle}>{primaryText}</div>
        <div className="secondary-text" style={secondaryTextStyle}>{secondaryText}</div>
      </div>
    </div>
  )
};

const InfoCardWidget = ({ primaryColor, secondaryColor, title, comment, icon, data, loading, children }) => {
  const cardStyle = {
    borderTop: `solid 3px ${primaryColor}`
  };

  const headerStyle = {
    color: primaryColor
  };

  const itemsInGroup = 2;

  const dataGroups = Array.from(Array(Math.ceil(data.length / itemsInGroup)),
                                (_,index) => data.slice(index * itemsInGroup, index * itemsInGroup + itemsInGroup));

  return (
    <Card className="statistics-widget" style={cardStyle} loading={loading}
          title={<Card.Meta className="statistics-widget-header" style={headerStyle}
                            avatar={<Icon type={icon} />} title={title} />}>

      <div className="statistics-widget-content">
        <Row>
          {comment}
        </Row>
        {
          dataGroups.map((dataGroup, index) => {
            return (
              <Row key={index}>
                {
                  dataGroup.map((item, index) => {
                    return (
                      <Col span={24 / dataGroup.length} key={index}>
                        <InfoElement {...item} {...{ primaryColor, secondaryColor }} />
                      </Col>
                    );
                  })
                }
              </Row>
            );
          })
        }
        <Row>
          { children }
        </Row>
      </div>
    </Card>
  );
};

export default InfoCardWidget;



// WEBPACK FOOTER //
// ./src/components/statisticsWidgets/infoCardWidget.js